// extracted by mini-css-extract-plugin
export const header = "header-module--header--_rwsu";
export const header__logo = "header-module--header__logo--Elpa2";